import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {client} from "../../services/client";
import { ENDPOINTS } from "../../config";

const initialState = {
  token: null,
  status: "idle",
  error: null,
};

export const fetchCredentials = createAsyncThunk(
  "auth/fetchCredentials",
  async (payload) => {
    const { name, password } = payload;
    if (name === "Prakash" && password === "12345") {
      return { token: "mock-token" }; // Simulated successful login response
    } else {
      throw new Error("Invalid credentials"); // Simulated error response
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    clearToken: (state) => {
      state.token = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCredentials.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCredentials.fulfilled, (state, action) => {
    
        state.status = "succeeded";
        state.token = action.payload.token;
        state.error = null;
      })
      .addCase(fetchCredentials.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message ?? "Something went wrong.";
      });
  },
});

export const { setToken, clearToken } = authSlice.actions;
export default authSlice.reducer;
